/**
 * Specifies the condition of title transfer.
 * tag: 41069
 * @readonly
 * @enum {number} (int)
 */
export enum DeliveryStreamTitleTransferCondition {
  /** Transfers with risk of loss */
  Transfers = 0,
  /** Does not transfer with risk of loss */
  DoesNotTransfer = 1,
}
